module.exports = "/assets/packs/images/5911a3b13f63f29dce6a6fedf33b93c8.png";